import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tooltip from '@mui/material/Tooltip';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';


const config = require("../constants/constants.js")
const { strCurrency, strEuroCurrency, strSubString } = require('../utils/currencyUtils.js')

const ServiceForListComponent = ({ serviceId, name, description, note, price, images, rating, reviewsNumber }) => {

  const url_dettagliservizio = "/service-details/" + serviceId;
  const url_image_dettagliservizio = config.URL_IMAGES_CUSTOMER1 + "dettagli-servizio.png";
  const help_image_dettagliservizio = "dettagli del servizio " + name;

  const navigate = useNavigate();

  const noteTruncate = note ? note.substring(0, 130) : '';
  
  let imageDimensionStyle = { width: '300px', height: '300px' };
    
  //  const Item = styled(Paper)(({ theme }) => ({
  //    backgroundColor: '#b6d6e0ff',
  //    backgroundColor: '#bfdae3ff',
  const Item = styled(Box)(({ theme }) => ({
    //backgroundColor: '#ffff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: (theme.vars ?? theme).palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));

  return (

    <Card xs={4} md={4}
      elevation={6}
      sx={{
        backgroundColor: '#ffffff',
        '&:hover': {
          backgroundColor: '#e9e9e9',
          opacity: [0.9, 0.8, 0.7],
        },
      }}>

      <Link to={url_dettagliservizio}>
        <CardMedia
          component="img"
          image={images[0] ? images[0].path : ''}
          alt=""
          sx={{ width: 300, paddingTop: 2, paddingLeft: 2, paddingRight: 2 }}
          style={imageDimensionStyle}
          crossOrigin="anonymous"
          variant="top"
        >
        </CardMedia>
      </Link>

      <CardContent
        sx={{
          width: '300px'
        }}
      >

        <Stack
          sx={{ flexDirection: { xs: "row", md: "row" } }}
        >
          <Box
            sx={{
              width: 270,
              maxHeight: { xs: 270, md: 270 },
              maxWidth: { xs: 270, md: 270 },
            }}
          >

            <Typography variant="body1"
              sx={{
                fontFamily: 'Arial',
                fontWeight: 700,
                fontSize: 20,
                color: 'text.primary',
              }}
            >
              {name}
            </Typography>

            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {description}
            </Typography>

             <Typography variant="body2"
                sx={{
                  fontFamily: 'sans-serif',
                  fontStyle: 'italic',
                  fontWeight: 300,
                  color: 'text.secondary',
                  fontSize: 11,
                  paddingTop: 1,
                  paddingRight: 3,
                }}
              >
                {noteTruncate}...
              </Typography>

              <Grid container spacing={2}
                sx={{
                  paddingTop: 2,
                }}
              >

                <Grid size={6}>
                  <Item>
                    <Typography variant="body2"
                      sx={{
                        color: 'text.secondary',
                        fontSize: 16,
                      }}
                    >
                      <b>{strEuroCurrency(price)}</b>
                    </Typography>
                  </Item>
                </Grid>

                <Grid size={6}>
                  <Item>
                    <Typography variant="body2"
                      sx={{
                        color: 'text.secondary',
                        paddingTop: 0,
                        fontSize: 14,
                      }}
                    >
                      <Rating
                        readOnly
                        size="small"
                        name="half-rating"
                        initialValue={rating}
                        precision={0.5}
                      />
                      ({reviewsNumber ? reviewsNumber : 0})
                    </Typography>
                  </Item>
                </Grid>

              </Grid>

          </Box>

          <Box
            sx={{
              paddingTop: 1, paddingLeft: 0, paddingRight: 0,
              maxWidth: { xs: 30, md: 30 },
            }}
          >
            <Link to={url_dettagliservizio}>
              <Tooltip title={help_image_dettagliservizio} arrow placement="right-end">
                <Box
                  component="img"
                  sx={{
                    height: 25,
                    width: 25,
                    maxHeight: { xs: 25, md: 25 },
                    maxWidth: { xs: 25, md: 25 },
                  }}
                  src={url_image_dettagliservizio}
                  onClick={event => {
                    navigate(url_dettagliservizio)
                  }}
                >
                </Box>
              </Tooltip>
            </Link>

          </Box>

        </Stack>

      </CardContent>

    </Card>

  );
};

export default ServiceForListComponent;
